import { useDelayedRender } from '@/hooks/useDelayedRender';

interface SkeletonCardProps {
  lines?: number;
  // Suppress the skeleton for the first `delayMs` so fast loads don't flash it.
  // Set 0 to render immediately.
  delayMs?: number;
}

export function SkeletonCard({ lines = 4, delayMs = 150 }: SkeletonCardProps) {
  const show = useDelayedRender(delayMs);
  if (!show) return null;
  return (
    <div className="border border-dash-border rounded-lg bg-dash-surface/40 p-4 space-y-3 aeo-fade-in">
      <div className="h-4 w-2/5 rounded aeo-shimmer" />
      {Array.from({ length: lines }, (_, i) => (
        <div key={i} className="h-3 rounded aeo-shimmer" style={{ width: `${60 + (i % 3) * 12}%` }} />
      ))}
    </div>
  );
}
